import { render, staticRenderFns } from "./location-view-page.vue?vue&type=template&id=37dbc0db&"
import script from "./location-view-page.vue?vue&type=script&lang=js&"
export * from "./location-view-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports